<template>
  <Tooltip placement="top">
    <template #trigger>
      <span class="text-primary">
        <i class="fa-solid fa-circle-info mr-1" />
        <b>Icons/Colors</b>
      </span>
    </template>
    <template #tooltip
      ><img :src="EquipmentIconsLegend" alt="legend"
    /></template>
  </Tooltip>
</template>

<script>
import EquipmentIconsLegend from "serviceshift-ui/shared/src/assets/equipment-icons_legend.png";

import Tooltip from "@/components/Tooltip.vue";

export default {
  name: "EquipmentIconsLegend",
  components: {
    Tooltip
  },
  data() {
    return {
      EquipmentIconsLegend
    };
  }
};
</script>

<style lang="scss" scoped></style>
